const TOKEN_KEY = 'proxy-portal-token'
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

export type ResultBody<T> = {
  code: number
  msg: string
  data?: T
}

type RequestOptions = {
  method?: string
  params?: Record<string, string | number | undefined | null>
  body?: unknown
}

export const getToken = () => localStorage.getItem(TOKEN_KEY)

export const setToken = (token: string) => localStorage.setItem(TOKEN_KEY, token)

export const clearToken = () => localStorage.removeItem(TOKEN_KEY)

export async function request<T>(url: string, options: RequestOptions = {}): Promise<T> {
  const query = new URLSearchParams()
  Object.entries(options.params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value))
    }
  })

  const target = `${API_BASE_URL}${url}${query.toString() ? `?${query.toString()}` : ''}`
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  }
  const token = getToken()
  if (token) {
    headers.eutoken = token
  }

  const response = await fetch(target, {
    method: options.method || 'GET',
    headers,
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
  })

  if (!response.ok) {
    throw new Error(`接口请求失败：${response.status}`)
  }

  const result = (await response.json()) as ResultBody<T>
  if (result.code !== 200) {
    throw new Error(result.msg || '接口请求失败')
  }
  return result.data as T
}
